import React from 'react'
import OtpInput from "react-otp-input";
import styled from 'styled-components'
import "../../Assets/styles/customPhoneSelect.css"
import 'react-phone-number-input/style.css'

import { colors } from '../../Assets/styles/colors';
import { useTranslate } from '@tolgee/react';
import LoginButton from '../GenericComponents/LoginButton';

const EnterOtpCode = ({
  otp,
  setOtp,
  wrongCode,
  handleVerifyCode,
  handleResendOTP,
}) => {
  const { t } = useTranslate();

  return (
    <Container>
      <LeftSide>
        <Card>

          <Group>
            <h1>{t('login.enter_code')}</h1>
            <OtpInputWrapper>
              <OtpInput
                containerStyle={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  gap: "5px"
                }}
                shouldAutoFocus
                inputStyle={wrongCode ? { borderColor: "red" } : {}}
                value={otp}
                onChange={setOtp}
                numInputs={6}
                renderSeparator={<span> </span>}
                renderInput={(props) => <input id="opt-input" {...props} />}
              />
            </OtpInputWrapper>
          </Group>
          {wrongCode && <WrongCodeStatus>
            <p>{t('login.wrong_validation_code')}</p></WrongCodeStatus>}
          <Group>
            <LoginButton
              style={{ padding: "16px" }}
              disabled={otp?.length < 6}
              id='verify-code-button'
              onClick={(e) => handleVerifyCode(otp)}
              text={t('login.verify_code')}
            />
            <TermsInfo>
              <p>{t('login.code_not_received')} <span onClick={() => handleResendOTP()}>{t('login.resend_code')}</span>
              </p>
            </TermsInfo>
          </Group>
        </Card>
      </LeftSide>
    </Container>
  )
}

export default EnterOtpCode
const Container = styled.div`
 display: flex;
  min-height: 600px;
  height: 100%;
  width: 100%;
  background:${({ theme }) => theme.menu.background};
`
const Card = styled.div`
display: flex;
  flex-direction: column;
  max-width: 500px;
  width: 100%;
  gap: 20px;
`

const OtpInputWrapper = styled.div`
  display: flex;
  width: 100%;

  input {
    padding: 14px 16px;
    min-width: 50px;
    border-radius: 10px;
    border: 1px solid ${({ theme }) => theme.sidebar.borderColor};
    color:${({ theme }) => theme.menu.primaryTextColor};
    background:${({ theme }) => theme.menu.enterPhoneNumberBackground};
    width: 100%;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    text-align: left;
    &:focus {
        outline: none;
      }
  }
  
`;

const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;

h1{
  color:${({ theme }) => theme.menu.primaryTextColor};
font-size: 32px;
font-weight: 600;
line-height: 39px;
letter-spacing: 0px;
text-align: left;
}

  
`;

const LeftSide = styled.div`
width:100%;
display:flex;
align-items:center;
justify-content:center;
padding:32px;
`


const TermsInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  p {
    color:${({ theme }) => theme.menu.secondaryTextColor};
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    text-align: center;
  }

  span {
    cursor: pointer;
     color:${({ theme }) => theme.menu.selectedTextColor};
    font-weight: 600;
    line-height: 22px;
    text-align: center;
    text-decoration: underline;
  }
`;

const WrongCodeStatus = styled.div`
p{
   color:${({ theme }) => theme.menu.deleteColor};
font-size: 14px;
font-weight: 500;
line-height: 17px;
letter-spacing: 0px;
text-align: left;

}
`
